import { typeInfo } from "../../../../constants/typeInfo";

const ScrambleButton = ({
  wordList,
  currentPage,
  handleClickWord,
  type,
  key = 1,
}) => {
  return wordList.slice().map((word, index) => {
    let userAnswer;
    if (type === "analysis") {
      const scrambleElements = currentPage.data?.question
        ?.filter((element) => element.type === "scramble") || [];
      userAnswer = scrambleElements[0]?.input || [];
    } else if (type === "comprehensive" || type === "sentence") {
      userAnswer = currentPage.input || [];
    }

    return (
      <div
        key={"scramble_" + index + "_" + key}
        style={{
          fontSize: "24px",
          padding: "12px 30px",
          border: currentPage.isSubmitted
            ? "1px solid #EBEBEB"
            : (userAnswer?.some((input) => input.index === word.index) || false) &&
              `1px solid ${typeInfo[type].color}`,
          borderRadius: "5px",
          boxShadow:
            !(userAnswer?.some((input) => input.index === word.index) || false) &&
            "0 0 5px rgba(0, 0, 0, 0.1)",
          backgroundColor: currentPage.isSubmitted
            ? "#EBEBEB"
            : (userAnswer?.some((input) => input.index === word.index) || false) &&
              typeInfo[type].color,
          color: currentPage.isSubmitted
            ? "#737373"
            : (userAnswer?.some((input) => input.index === word.index) || false) &&
              typeInfo[type].answerTextColor,
          transition: "all 0.3s",
        }}
        onClick={() => {
          handleClickWord(word);
        }}
      >
        {word.text}
      </div>
    );
  });
};

export default ScrambleButton;
